import React, {useState} from "react";
import Button from "../../../../../../../../components/base/button/button";
import BannerSelectionDialog from "../../../../../../../../components/dialogs/banner-selection";

const UserHomepageControlPanelComponentCreateBanner = ({
                                                           updating,
                                                           add,
                                                           remove,
                                                           multiSelect,
                                                           existingBanners = [],
                                                       }) => {
    const [bannerSelectionDialog, setBannerSelectionDialog] = useState(false);

    /**
     * Sets the selected banners obtained from the selection dialog.
     *
     * * removes each of the existing banners then adds the newly obtained banners through the given callbacks.
     * @param {any[]} banners
     */
    const setSelectedBanners = (banners) => {
        const _banners = banners?.map(e => ({
            id: e.id,
            imageName: e.imageFileInfo?.url ?? e.imageName,
            tags: e.tags?.map(e => ({
                id: e.id,
                name: e.name,
                isPublic: e.isPublic,
                iconFileName: e.iconInfo?.url,
            }))
        })) ?? [];
        for (const existingBanner of existingBanners) {
            remove(existingBanner);
        }
        for (const banner of _banners) {
            add(banner);
        }
    }

    return (
        <>
            <div className={'mx-2 d-flex align-items-center justify-content-center'}>
                <Button
                    disabled={updating}
                    variant={'contained'}
                    color={'primary'}
                    onClick={() => setBannerSelectionDialog(true)}
                >
                    {
                        updating
                            ? "Processing..."
                            : multiSelect ? 'Select Banners' : 'Add Banner'
                    }
                </Button>
            </div>
            <BannerSelectionDialog
                existingBanners={existingBanners}
                open={bannerSelectionDialog}
                close={() => setBannerSelectionDialog(false)}
                onSuccess={setSelectedBanners}
                multiSelect={multiSelect}
            />
        </>
    )
}

export default UserHomepageControlPanelComponentCreateBanner;
